export function SQLInjectionCo() {
    const courses = [
      { 
        title: "HTML and CSS in depth (From CiCdCo)", 
        url: "https://www.coursera.org/learn/html-and-css-in-depth"
      },
      { 
        title: "HTML for Beginners: Getting Started (Project Network)", 
        url: "https://www.coursera.org/projects/html-for-beginners-getting-started"
      },
      { 
        title: "Introduction to HTML (Project Network)", 
        url: "https://www.coursera.org/projects/introduction-to-html"
      },
      { 
        title: "HTML & CSS Crash Course (From Scrimba)", 
        url: "https://www.coursera.org/learn/html--css-crash-course"
      },
      { 
        title: "Build a Webpage with HTML and CSS (BOORD infinity)", 
        url: "https://www.coursera.org/learn/build-a-webpage-with-html-and-css"
      }
    ];
  
    return (
      <>
        <h1 className="html_co_heading">
          These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 5</strong> recommended Coursera courses links that you can refer with certifications
        </h1>
  
        <h4 className="des_co_html">
          1. Dive Into The Main Concepts <br />
          2. Animation Explanations with real-world Examples <br />
          3. Important with Note Clarification.
        </h4>
  
        {courses.map((course, index) => (
          <div key={index} className="container_html_co_links">
            <p className="vid">{index + 1}. {course.title}
              <button 
                style={{ marginLeft: '200px', padding: '7px', background: 'black', color: 'white', borderRadius: '8px' }}
                onClick={() => window.open(course.url, "_blank")}
                aria-label={`Go to ${course.title}`}
              >
                Click Me
              </button>
            </p>
          </div>
        ))}
      </>
    );
  }
  
  export default SQLInjectionCo;
  